module.exports = __webpack_public_path__ + "img/badovl_color.ff9d47b8.png";